export const API_ENDPOINTS = {
  SITE_PAGE: '/api/v1/pageBlock/',
  LEAD_FORM: '/api/v1/lead',
  IMAGE_URL: '/api/imageUrl',
  SEARCH_URL: '/api/v1/pageBlock/search',
  CASES_URL: '/api/v1/listing',
  METADATA: '/api/v1/page',
};
